import { SessionStorageKeys } from "@/common/browserStorage/constants";

export const SYNTAX_ERROR_ERROR_MESSAGE = "SyntaxError: Unexpected token '<'";
export const CHUNK_LOAD_ERROR_MESSAGE = "ChunkLoadError";

function setRecoveryUrl() {
  const pendingUrl = sessionStorage.getItem(SessionStorageKeys.PendingUrl);
  if (pendingUrl) {
    sessionStorage.setItem(SessionStorageKeys.RecoveryUrl, pendingUrl);
  }
}

function reloadApp() {
  window.location.reload();
}

window.addEventListener("error", (event: any) => {
  const message = event.message || "";

  // if (window.location.pathname.endsWith(FATAL_ERROR_PATH)) return;

  if (message.includes(SYNTAX_ERROR_ERROR_MESSAGE)) {
    event.preventDefault();
    setRecoveryUrl();
    return reloadApp();
  }

  // const encodedMsg = encodeURIComponent(message);
  // window.location.href = `${FATAL_ERROR_PATH}?msg=${encodedMsg}`;
});

window.addEventListener("DOMContentLoaded", () => {
  const recoveryUrl = sessionStorage.getItem(SessionStorageKeys.RecoveryUrl);

  if (recoveryUrl) {
    sessionStorage.removeItem(SessionStorageKeys.RecoveryUrl);
    window.location.replace(recoveryUrl);
  }
});
